module.exports = __webpack_public_path__ + "static/scott_halftone_wbanner-d31b3d0ea1015a932f7f922a218d889a.png";